"use client"

import RequisitionsModal from "@/components/requisitions/RequisitionsModal"
import RequisitionsTable from "@/components/requisitions/RequisitionsTable"
import { DropdownInterface } from "@/components/ui/dropdown"
import { RequisitionsSchema } from "@/schemas/requisitions.schema"
import { getRequisitionDomains } from "@/services/domains.service"
import { getRequisitionsEntries } from "@/services/requisition.service"
import { useEffect, useState } from "react"
import z from "zod"

export default function Requisitions(){
    const [dataFetched, setDataFetched] = useState(false);
    const [requisitionsEntries, setRequisitionEntries] = useState<z.infer<typeof RequisitionsSchema>[]>([]);
    const [domains, setDomain] = useState<DropdownInterface[]>([]);

    async function updateData() {
        var entries = null;
        try {
            entries = await getRequisitionsEntries();
        } catch (error) {
            console.log("----------------- Error Occurred - getRequisitionsEntries -----------------");
            console.log(error);
        }
        setRequisitionEntries(entries ?? []);
    }

    useEffect(() => {
        const getentries = async () => {
            var entries = null;
            try {
                entries = await getRequisitionsEntries();
            } catch (error) {
                console.log("----------------- Error Occurred - getRequisitionsEntries -----------------");
                console.log(error);
            }
            setRequisitionEntries(entries ?? []);
        }
        
        const getDomains = async () => {
            var domains: DropdownInterface[] = [];
            try {
                var response = await getRequisitionDomains();
                domains = Object.keys(response).map(function (domainIndex) {
                    const domain = response[Number(domainIndex)];
                    return {id: Number(domain.ID), value: domain.ID, text: domain.Name};
                });
            } catch (error) {
                console.log("----------------- Error Occurred - getRequisitionDomains -----------------");
                console.log(error);
            }
            setDomain(domains ?? []);
        }

        if(!dataFetched) {
            setDataFetched(true);
            getentries();
            getDomains();
        }
    }, [dataFetched, requisitionsEntries, domains])

    return (
        <div>
            <RequisitionsModal domains={domains} updateData={updateData}/>
            <RequisitionsTable requisitionsEntries={requisitionsEntries} updateData={updateData}/>
        </div>
    )
}